import React, { useState, useRef, useEffect } from 'react';
import './OrderNowButton.css';

const OrderNowButton = ({ theme = 'dark', deliveryLinks = {} }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Default delivery links if none provided
  const defaultLinks = {
    doordash: 'https://www.doordash.com/store/drakes-san-carlos-2839054/?srsltid=AfmBOorRwHExebd09BfkZE4XA_3WisSOUC6clx6I0hFpGpwm7hBKKUgA',
    grubhub: 'https://www.grubhub.com/restaurant/drakes-1101-san-carlos-ave-san-carlos/3133047',
    ubereats: 'https://www.ubereats.com/store/drakes/tLY6If8aWl-Nh8pfYJetNQ?srsltid=AfmBOoqyd12dkD2QDqHNxQYIrFauAvh3BzfkOSY8U9phnN1QDuDkdgGd'
  };

  const links = {
    ...defaultLinks,
    ...deliveryLinks
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className={`order-now-container ${theme}`} ref={dropdownRef}>
      <button 
        className="order-now-button"
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        aria-haspopup="true"
      >
        Order Now
        <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
      </button>
      
      {isOpen && (
        <div className="delivery-dropdown" role="menu">
          <a 
            href={links.doordash}
            target="_blank"
            rel="noopener noreferrer"
            className="delivery-option"
            role="menuitem"
          >
            DoorDash
          </a>
          {links.ubereats && (
            <a 
              href={links.ubereats}
              target="_blank"
              rel="noopener noreferrer"
              className="delivery-option"
              role="menuitem"
            >
              Uber Eats
            </a>
          )}
          <a 
            href={links.grubhub}
            target="_blank"
            rel="noopener noreferrer"
            className="delivery-option"
            role="menuitem"
          >
            GrubHub
          </a>
        </div>
      )}
    </div>
  );
};

export default OrderNowButton; 